import React from 'react';
import FinderSection from '../components/Finder/FinderSection';

export default FinderSection